import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: ${({ $size }) => {
    if ($size === "sm") return "16px";
    if ($size === "lg") return "48px";
    return "32px";
  }};
  height: ${({ $size }) => {
    if ($size === "sm") return "16px";
    if ($size === "lg") return "48px";
    return "32px";
  }};
  border: ${({ $size }) => {
    if ($size === "sm") return "2px";
    if ($size === "lg") return "4px";
    return "3px";
  }} solid ${({ theme }) => theme.colors.light?.primary || theme.colors.landing?.accent?.primary || "hsl(258, 90%, 58%)"}20;
  border-top-color: ${({ theme }) => theme.colors.light?.primary || theme.colors.landing?.accent?.primary || "hsl(258, 90%, 58%)"};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export function LoadingSpinner({ size = "md", ...props }) {
  return <Spinner $size={size} {...props} />;
}

export function PageLoader() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ textAlign: "center" }}>
        <LoadingSpinner size="lg" style={{ margin: "0 auto 16px" }} />
        <p style={{ color: "hsl(240, 10%, 45%)" }}>Loading...</p>
      </div>
    </div>
  );
}
